import { Device } from 'DeviceUtils';
import { Platform, StyleSheet } from 'react-native';
import Theme from 'Theme';

const defaultStyles = {
    mainContainer: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    },
    container: {
        height: Device.isTabletOrWeb ? 60 : Theme.playerHeaderHeight,
        alignSelf: 'stretch',
        flexDirection: 'row',
        paddingHorizontal: Platform.OS === 'ios' ? 15 : 30,
        zIndex: 2,
        width: '100%'
    },
    backIconContainer: {
        flexDirection: 'row',
        zIndex: 2,
        alignSelf: 'center'
    },
    backIcon: {
        width: 29,
        height: 29,
        alignSelf: 'center',
        marginEnd: 15
    },
    header: {
        position: 'absolute',
        width: '100%',
        top: 0,
        marginTop: 20,
        backgroundColor: 'rgba(0,0,0,0.3)'
    },
    behind: {
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#000000'
    }
};

if (Device.isTabletOrWeb) {
    defaultStyles.mainContainer = {
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        position: 'absolute'
    };
    defaultStyles.container = {
        ...defaultStyles.container,
        alignSelf: 'center',
        maxHeight: 50
    };
}

export default StyleSheet.create(defaultStyles);
